import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import Global from '../../../../store/global-selectors';
import messages from '../messages';
import getDisplayInformation from '../../../../components/data-driven-logo/get-display-information';

const InternationalProviderColumn = ({ id: presetGroupId }) => {
  const internationalProviderId = useSelector((state) =>
    Global.selectEntitiesPresetGroupPropertyById(state, {
      profileId: presetGroupId,
      property: 'intlProviderId',
    }),
  );

  const providerId = Number.parseInt(internationalProviderId, 10);
  const displayInformation = getDisplayInformation({ providerId });
  if (!displayInformation) {
    return '';
  }
  return displayInformation.name;
};

InternationalProviderColumn.propTypes = {
  id: PropTypes.string.isRequired,
};

export default {
  getMessageDescriptor: messages.internationalProviderColumn,
  name: <FormattedMessage {...messages.internationalProviderColumn} />,
  id: 'internationalProvider',
  isSortable: false,
  render: InternationalProviderColumn,
};
